import { HomeComponent } from "./components/home.component";
import { AuthRequiredComponent } from "./components/auth-required.component";
import { SelectOrganizationComponent } from "./components/select-organization.component";
import { Route, mapToCanActivate } from "@angular/router";
import { HomeGuard } from "./components/guards/home.guard";

export const CORE_ROUTES: Route[] = [
    {
        path: "select-organization",
        component: SelectOrganizationComponent
    },
    {
        path: "login",
        component: HomeComponent
    },
    {
        path: "",
        component: HomeComponent,
        canActivate: mapToCanActivate([
            HomeGuard
        ])
        },
    { path: "unauthorized", component: AuthRequiredComponent }
]